<template>
	<div class="loading">
		<v-progress-circular
			indeterminate
			color="css"
			size="47"
			class="loading__progress"
		/>
		<h2 class="tertiary">{{ name }}</h2>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss">
.loading {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 550px;
	height: 250px;
	padding-top: 0;
	margin: 0 auto;
	background-color: $white;
	box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
}

.loading__progress {
	margin-bottom: 25px;
	color: --var(primary-color);
}

@media only screen and (max-width: 767px) {
	.loading {
		width: auto;
		margin: 0;
		min-height: calc(100% - 80px);
		max-width: 100%;
	}
}
</style>
